import React from 'react';
import { useChannelContext } from '../context/ChannelContext';

const Sidebar = ({ onSelectChannel }) => {
  const { channels, currentFilter, currentChannel, setCurrentFilter, getLiveChannels } = useChannelContext();
  const liveChannels = getLiveChannels();

  const categories = [
    { key: 'all', label: 'All Channels', icon: '📡' },
    { key: 'worldcup', label: 'World Cup', icon: '🏆' },
    { key: 'sports', label: 'Sports', icon: '⚽' },
    // { key: 'news', label: 'News', icon: '📰' },
    // { key: 'entertainment', label: 'Entertainment', icon: '🎬' },
    // { key: 'religious', label: 'Religious', icon: '🕌' },
    // { key: 'kids', label: 'Kids', icon: '👶' },
    // { key: 'movies', label: 'Movies', icon: '🎥' },
    // { key: 'music', label: 'Music', icon: '🎵' },
  ];

  return (
    <aside style={{
      width: '200px',
      flexShrink: 0,
      background: 'var(--surface)',
      borderRight: '1px solid var(--border)',
      position: 'fixed',
      top: '56px',
      bottom: 0,
      left: 0,
      overflowY: 'auto',
      padding: '12px 0',
      zIndex: 100,
      transform: 'translateX(-100%)',
      transition: 'transform 0.3s ease',
      '@media (min-width: 768px)': {
        transform: 'translateX(0)',
        position: 'fixed'
      }
    }} className="sidebar">
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          fontSize: '9px',
          fontWeight: 700,
          color: 'var(--muted)',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          padding: '0 12px 6px'
        }}>Live Now</div>
        {liveChannels.slice(0, 8).map(ch => (
          <div
            key={ch.id}
            onClick={() => onSelectChannel(ch.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              cursor: 'pointer',
              transition: '0.15s',
              borderLeft: '3px solid transparent',
              fontSize: '12px',
              fontWeight: 500,
              color: currentChannel?.id === ch.id ? 'var(--text)' : 'var(--muted)',
              background: currentChannel?.id === ch.id ? 'var(--card)' : 'transparent',
              borderLeftColor: currentChannel?.id === ch.id ? 'var(--accent)' : 'transparent'
            }}
          >
            <span style={{ fontSize: '14px', width: '18px', textAlign: 'center' }}>
              {ch.icon && ch.icon.startsWith('http') ? '📺' : (ch.icon || '📺')}
            </span>
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {ch.name}
            </span>
            <span style={{
              width: '6px',
              height: '6px',
              background: 'var(--live)',
              borderRadius: '50%',
              flexShrink: 0,
              animation: 'pulse 1.5s infinite'
            }}></span>
          </div>
        ))}
      </div>

      <div>
        <div style={{
          fontSize: '9px',
          fontWeight: 700,
          color: 'var(--muted)',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          padding: '0 12px 6px'
        }}>Categories</div>
        {categories.map(cat => (
          <div
            key={cat.key}
            onClick={() => setCurrentFilter(cat.key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              cursor: 'pointer',
              transition: '0.15s',
              borderLeft: '3px solid transparent',
              fontSize: '12px',
              fontWeight: 500,
              color: currentFilter === cat.key ? 'var(--text)' : 'var(--muted)',
              background: currentFilter === cat.key ? 'var(--card)' : 'transparent',
              borderLeftColor: currentFilter === cat.key ? 'var(--accent)' : 'transparent'
            }}
          >
            <span style={{ fontSize: '14px', width: '18px', textAlign: 'center' }}>{cat.icon}</span>
            {cat.label}
          </div>
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.3); }
        }
        
        @media (min-width: 768px) {
          .sidebar {
            transform: translateX(0) !important;
          }
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;